import React, { useEffect, useMemo, useState } from "react";
import { Tab, Tabs } from "react-bootstrap";
import { useSearchParams } from "react-router-dom";
import AdLayout from "../../components/AdLayout";
import "./accountingResponsive.css";
import ReceivableList from "./ReceivableList";
import PayableList from "./PayableList";
import axiosInstance from "../../axiosInstance";
import {
  fetchAccountingPermissions,
  ACCOUNTING_DEBT_RECEIVABLE,
  ACCOUNTING_DEBT_PAYABLE,
} from "../../libs/customerCreatePermission";

const DebtManagement = () => {
  const [searchParams, setSearchParams] = useSearchParams();
  const tab = searchParams.get("tab") || "receivable";
  const [canReceivable, setCanReceivable] = useState(false);
  const [canPayable, setCanPayable] = useState(false);
  const [permLoaded, setPermLoaded] = useState(false);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      const [recv, pay] = await Promise.all([
        fetchAccountingPermissions(axiosInstance, ACCOUNTING_DEBT_RECEIVABLE),
        fetchAccountingPermissions(axiosInstance, ACCOUNTING_DEBT_PAYABLE),
      ]);
      if (cancelled) return;
      setCanReceivable(Boolean(recv?.canView));
      setCanPayable(Boolean(pay?.canView));
      setPermLoaded(true);
    })();
    return () => { cancelled = true; };
  }, []);

  const allowedTabs = useMemo(() => {
    const tabs = [];
    if (canReceivable) tabs.push("receivable");
    if (canPayable) tabs.push("payable");
    return tabs;
  }, [canReceivable, canPayable]);

  useEffect(() => {
    if (!permLoaded || allowedTabs.length === 0) return;
    if (!allowedTabs.includes(tab)) {
      const next = new URLSearchParams(searchParams);
      next.set("tab", allowedTabs[0]);
      setSearchParams(next, { replace: true });
    }
  }, [permLoaded, allowedTabs, tab, searchParams, setSearchParams]);

  const handleTabSelect = (key) => {
    if (!key || !allowedTabs.includes(key)) return;
    setSearchParams({ tab: key });
  };

  if (!permLoaded) return null;

  return (
    <AdLayout>
      <div className="acc-page">
        <h5 className="fw-bold mb-3">Quản lý Công nợ</h5>
        <Tabs
          activeKey={allowedTabs.includes(tab) ? tab : allowedTabs[0]}
          onSelect={handleTabSelect}
          className="mb-3 acc-tabs-scroll"
        >
          {canReceivable && (
            <Tab eventKey="receivable" title="Phải thu">
              {tab === "receivable" && <ReceivableList embedded />}
            </Tab>
          )}
          {canPayable && (
            <Tab eventKey="payable" title="Phải trả">
              {tab === "payable" && <PayableList embedded />}
            </Tab>
          )}
        </Tabs>
      </div>
    </AdLayout>
  );
};

export default DebtManagement;
